__turbopack_context__.v({
  "root": "GradientTypography-module-scss-module__AKwGaa__root",
  "titleLine": "GradientTypography-module-scss-module__AKwGaa__titleLine",
  "titleMeasure": "GradientTypography-module-scss-module__AKwGaa__titleMeasure",
});
